// extracted by mini-css-extract-plugin
module.exports = {"dummyView":"dummy_dummyView__33TnX"};